export default "__VITE_ASSET__b060d695__"